module.exports = __webpack_public_path__ + "static/media/baterias.98a72655.png";